module.exports = __webpack_public_path__ + "static/img/icon-noti-lock.eda43238.svg";